import { render, staticRenderFns } from "./escapeList.vue?vue&type=template&id=008065ce&scoped=true&"
import script from "./escapeList.vue?vue&type=script&lang=js&"
export * from "./escapeList.vue?vue&type=script&lang=js&"
import style0 from "./escapeList.vue?vue&type=style&index=0&id=008065ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008065ce",
  null
  
)

export default component.exports